'use client';

import React from 'react';
import { Box, List, ListItem } from '@mui/material';
import Link from 'next/link';
import DynamicLogo from '@components/DynamicLogo';
import DynamicButton from '@components/DynamicButton';
import CommonDynamicButton from '../CommonDynamicButton';
import cn from './style.module.scss';
export default function MobileNavigation(props: any) {
  const mobileNavigationItems =
    props.locale.section?.westminsterTowerNavigationMobile || [];
  return (
    <Box className={cn.westminsterMobileDrawer}>
      <Box className={cn.westminsterMobileLogo}>
        <Link
          href="/en/westminstertower"
          className={cn.westminsterMobileLogo__element}
        >
          <DynamicLogo
            logoImage={props?.images?.westminster_tower_logo_light?.src}
            alt="Westminster Tower Logo"
          />
        </Link>
      </Box>
      <Box className={cn.westminsterMobileNavigation}>
        <List className={cn.westminsterMobileList}>
          {mobileNavigationItems.map((item: any, index: number) => (
            <ListItem key={index} className={cn.westminsterMobileItem}>
              <Link
                className={`${cn.westminsterMobileLink} ${
                  item.className ? cn[item.className] : ''
                }`}
                href={item.url}
              >
                {item.label}
              </Link>
            </ListItem>
          ))}
        </List>
        <Box className={cn.westminsterNavigationMobileButton}>
          <CommonDynamicButton
            className={cn.westminsterNavigationMobileButton__element}
            elementClassName={cn.navigationButtonItem}
            label={
              props.locale.section['westminsterTowerNavigationButton'] ||
              'contact'
            }
            scrollToId="westminsterTowerRegistrationID"
          />
        </Box>
      </Box>
      <Box className={cn.westminsterMobileLSQ}>
        <Box className={cn.westminsterMobileLSQ__element}>
          <DynamicLogo
            logoImage={props?.images?.westminster_tower_lsq_logo?.src}
            alt={'Wimbledon Bridge Logo'}
          />
        </Box>
      </Box>
    </Box>
  );
}
